import { Component, inject, input } from '@angular/core';
import { AiToolForm } from '../../../core/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { AiToolHeaderFormArrayComponent } from '../ai-tool-header-form-array/ai-tool-header-form-array.component';
import { AiToolParameterFormArrayComponent } from '../ai-tool-parameter-form-array/ai-tool-parameter-form-array.component';
import { CurlImportDialogComponent, CurlImportResult } from '../../ai-function-form/curl-import-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { MatInputModule } from '@angular/material/input';
import { AiToolCurlService } from '../../../core/services/ai-tool-curl.service';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Clipboard } from '@angular/cdk/clipboard';
import { DismissibleInfoBannerComponent } from '../../shared/dismissible-info-banner/dismissible-info-banner.component';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

@Component({
  selector: 'ai-tool-form',
  imports: [
    AiToolHeaderFormArrayComponent,
    AiToolParameterFormArrayComponent,
    ReactiveFormsModule,
    GalaxyFormFieldModule,
    TranslateModule,
    MatButtonModule,
    MatCardModule,
    MatMenuModule,
    MatSelectModule,
    MatIconModule,
    GalaxyTooltipModule,
    MatInputModule,
    DismissibleInfoBannerComponent,
  ],
  templateUrl: './ai-tool-form.component.html',
  styleUrl: './ai-tool-form.component.scss',
})
export class AiToolFormComponent {
  private readonly dialog = inject(MatDialog);
  private readonly aiToolCurlService = inject(AiToolCurlService);
  private readonly clipboard = inject(Clipboard);
  private readonly snackbarService = inject(SnackbarService);
  readonly form = input.required<AiToolForm>();

  protected readonly httpMethods = Array.from<HttpMethod>(['GET', 'POST', 'PUT', 'PATCH', 'DELETE']);

  protected readonly commonHeaderOptions = [
    { label: 'Content-Type: JSON', header: { key: 'Content-Type', value: 'application/json' } },
    { label: 'Accept: JSON', header: { key: 'Accept', value: 'application/json' } },
    { label: 'Authorization', header: { key: 'Authorization', value: 'YOUR_TOKEN_HERE' } },
  ];

  openCurlImportDialog(): void {
    const dialogRef = this.dialog.open(CurlImportDialogComponent, {
      width: '600px',
      disableClose: false,
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((result: CurlImportResult) => {
      if (result) {
        const func = this.aiToolCurlService.curlCommandToFunction(
          result,
          this.form().getRawValue().id || undefined,
          this.form().getRawValue().description || undefined,
        );
        this.form().merge(new AiToolForm({ func: func }));
      }
    });
  }

  copyCurlCommand(): void {
    const curlCommand = this.aiToolCurlService.functionToCurlCommand(this.form().toFunction());
    this.clipboard.copy(curlCommand);
    this.snackbarService.openSuccessSnack('Copied cURL command to clipboard');
  }
}
